import { AdImages as SharedAdImages, AdImagesProps } from "@kaltura/mediaspace-shared-ui";

/**
 * AdImages Component displays two AD images with links - in media page module data section for imagePlacements module
 */
export function AdImages(props: AdImagesProps) {
    return <SharedAdImages {...props} baseClass={"kms-ds-media-page-image-placements"} />;
}

export default AdImages;
